{
  "attribute_config": {
    "cacheData": {
      "label": "自动填写上次提交内容"
    },
    "showPartDescription": {
      "label": "描述较长时折叠展示"
    },
    "presence": {
      "label": "字段必填"
    },
    "choices": {
      "actions": {
        "add": "添加选项",
        "add_other": "添加“其他”"
      },
      "default_names": ["选项一", "选项二", "选项三"],
      "default_name": "选项",
      "default_name_other": "其他"
    },
    "private": {
      "label": "字段隐藏"
    }
  },
  "field_action": {
    "copy": "复制字段",
    "delete": "删除字段"
  }
}
